import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import CategoryList from 'components/Lists/CategoryList'
import TextInput from 'components/Inputs/TextInput'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { FaPlus } from 'react-icons/fa'
import { ListContainer, FilterContainer } from '../styles'

export default function ServiceCategories () {
  const [query, setQuery] = useState ('')
  const [loading, setLoading] = useState (true)
  const [categories, setCategories] = useState ([])
  const token = AuthService.getToken ()
  const navigate = useNavigate ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [query])

  const getData = async () => {
    try {
      setLoading (true)

      const { data: categories } = await cutileiApi.get (
        `/service_categories?name=${encodeURIComponent (query)}`, requestConfig
      )

      setCategories (categories)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <ListContainer>
      <FilterContainer>
        <TextInput
          value={query}
          placeholder='Pesquisar por nome'
          isClearable={true}
          onChange={e => setQuery (e.target.value)}
          onClear={() => setQuery ('')}
          containerStyle={{width: 280}}
          inputStyle={{boxShadow: '0px 1px 10px -6px', paddingInline: 12}}
        />
        <SecondaryButton
          label='Nova categoria'
          leftIcon={<FaPlus size={12} color='#FFC100' style={{marginBottom: 2}}/>}
          onClick={() => navigate ('/admin/service_categories/new')}
          width={150}
        />
      </FilterContainer>
      {loading ? <Loading style={{marginTop: 30}}/> :
        <CategoryList categories={categories} categoryType='service'/>
      }
    </ListContainer>
  )
}
